module.exports = __webpack_public_path__ + "media/images/athletes/1874-4cf48826b823752b9bf0054f1a37bd7c.png";